import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";

import info from "../../../../../images/info.png";

import deleteIcon from "../../../../../images/training/delete-red.png";
import codeIcon from "../../../../../images/training/bracket.png";
import rtbmenu from "../../../../../images/training/rtb-menu.png";
import cloneIcon from "../../../../../images/training/clone.png";
import { deleteGenAiSkills } from "../../../../../redux/actions/skill";
const V2SkillCards = (props) => {
  const dispatch = useDispatch();
  const item = props.skill;
  const [itemId, setItemId] = useState("");
  const history = useHistory();
  const userEmail = useSelector((state) => state.userReducer?.user?.email);
  const userRole = useSelector(
    (state) => state.organizationReducer.currentOrgUser
  );

  useEffect(() => {
    window.$('[data-toggle="popover"]').popover({ container: "body" });
  }, []);

  const deleteV2Skill = async () => {
    await dispatch(deleteGenAiSkills(itemId));
    history.push("/dashboard/skills/viewAutomationV2");
  };
  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const sanitizedDescription = removeHtmlTags(item.description);
  return (
    <div>
      {" "}
      <div className="col-md-4 ss-block pdl-0">
        <div className="tpb-outer">
          <div className="ss-box">
            <div className="rtb-menu draft-menu">
              <div class="dropdown">
                <a
                  class="rtb-menu-btn"
                  type="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={rtbmenu} />
                </a>

                <ul class="dropdown-menu dropdown-menu-left pull-right">
                  {userRole?.role_id === "2" || item?.email === userEmail ? (
                    <li
                      onClick={() => {
                        setItemId(item?.id);
                      }}
                      data-toggle="modal"
                      data-target="#DeleteV2Modal"
                    >
                      <button>
                        <span>
                          <img src={deleteIcon} />
                        </span>{" "}
                        Delete
                      </button>
                    </li>
                  ) : null}
                </ul>
              </div>

              {item.email ? (
                <span className="hlp-email">{item.email}</span>
              ) : null}
            </div>

            <div
              className="ss-title-cont"
              onClick={() =>
                history.push(
                  `/dashboard/skills/createAutomationV2/${encodeURIComponent(item?.SKILL_NAME)}&${item?.v2AgentId}&${item?.v2SkillId}`
                )
              }
            >
              <div
                className="ss-ico ss-text"
                style={{ backgroundColor: props.color }}
              >
                <p>{item.name.substring(0, 2)}</p>
              </div>

              <div className="hp-content">
                <h5 title={item.name}>
                  {item.name && item.name.substring(0, 35)}
                  {item.name && item.name.length > 35 ? (
                    <span>
                      <strong>...</strong>
                    </span>
                  ) : null}
                </h5>

                <div className="overflow-text">
                  <div className="inner-text">
                    <div
                      className="inner-text-hidden"
                      dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                    ></div>

                    {item.description && item.description.length > 100 ? (
                      <>
                        <a
                          class="tlt-icon tl-tooltip"
                          href="javascript:void(0)"
                          data-toggle="popover"
                          data-html="true"
                          data-trigger="hover"
                          data-placement="auto right"
                          data-content={sanitizedDescription}
                          title="Description"
                        >
                          <img src={info} alt="" />
                        </a>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="ss-footer">
              <div className="use-now">
                <button
                  className="btn btn-default use-button"
                  onClick={() => {
                    history.push(
                      `/dashboard/skills/createAutomationV2/${encodeURIComponent(item?.SKILL_NAME)}&${item?.v2AgentId}&${item?.v2SkillId}`
                    );
                  }}
                >
                  View Now
                </button>
              </div>

              <div className="brand-list" title={"GenAi - Automation"}>
                GenAi-Automation
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Delete modal V2 */}
      <div className="modal fade qa-modal1" id="DeleteV2Modal" role="dialog">
        <div className="modal-dialog modal-sm">
          <div className="modal-content share-modal">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <div className="modal-body">
              <h3 className="qa-modal-title">Delete</h3>
              <div>
                <h5>Please confirm delete action.</h5>
              </div>

              <div className="frm-btns fb-right">
                <button className="btn-outline" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  className="btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    deleteV2Skill();
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default V2SkillCards;
